export class Tabs {
	private static readonly tabSections: Tabs[] = [];

	public static init(): void {
		const elements = document.getElementsByClassName('tabs');
		for (const element of elements) {
			this.tabSections.push(new Tabs(element as HTMLDivElement));
		};
	}

	public readonly tabs: Tab[] = [];

	constructor(public readonly element: HTMLElement) {
		this.element.querySelectorAll<HTMLButtonElement>('nav > button[data-tab]').forEach((tab) => {
			this.tabs.push(new Tab(this, tab));
		});
	}
}

class Tab {
	private readonly id: string;
	public readonly content: HTMLLIElement;

	constructor(private readonly tabs: Tabs, public readonly trigger: HTMLButtonElement) {
		this.id = this.trigger.dataset.tab as string;
		this.content = document.getElementById(`tab-${this.id}`) as HTMLLIElement;
		this.trigger.addEventListener('click', () => this.activate());
	}

	public activate(): void {
		for (const tab of this.tabs.tabs) for (const element of ['trigger', 'content'] as const) {
			tab[element].classList.toggle('active', tab === this);
		}
	}
}
